var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"120"}},[_c('div',{domProps:{"textContent":_vm._s(_vm.count==undefined?'Loading ...':_vm.count)}})]),(_vm.count!=undefined)?_c('div',{staticClass:"PrimaryFontColorXSmall"},[_vm._v("Verifying...Please wait...")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }